import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  width: 18rem;
`;

export const SuggestionsContainer = styled.div<{ show: boolean }>`
  position: absolute;
  top: 100%;
  left: 0.5%;
  right: 0;
  background: white;
  border: 0.1rem solid ${({ theme }) => theme.color.gray[200]};
  border-top: none;
  border-radius: 0 0 0.3rem 0.3rem;
  box-shadow: 0 0.2rem 0.5rem ${({ theme }) => theme.color.gray[150]};
  z-index: 1000;
  max-height: 15rem;
  overflow-y: auto;
  width: 17.45rem;
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

export const SuggestionItem = styled.div<{ highlighted: boolean }>`
  font-size: 0.8rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  background-color: ${({ theme, highlighted }) => (highlighted ? theme.color.gray[500] : theme.color.gray[0])};
  border-bottom: 0.1rem solid ${({ theme }) => theme.color.gray[0]};

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[150]};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const SuggestionText = styled.div`
  color: ${({ theme }) => theme.color.gray[1000]};
`;

export const SuggestionMeta = styled.div`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.color.gray[500]};
  margin-top: 0.2rem;
`;
